"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertIsRefWrapper = void 0;
var id_1 = require("../id");
exports.assertIsRefWrapper = {
    "ref": (0, id_1.id)(undefined),
};
//# sourceMappingURL=assertIsRefWrapper.js.map